import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.244 13.881a1.073 1.073 0 0 0 1.516 0l6.426-6.426a1.073 1.073 0 0 0-1.516-1.516L10 11.609 4.33 5.942a1.073 1.073 0 0 0-1.516 1.516l6.426 6.427z"
    }, null, -1)
  ]))]))
}
export default { render: render }